import React from "react";
import { get } from "lodash";
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { MenuItem, Box } from "@mui/material";

import { useSearchCustomersContext } from "../../../../context";
import CardLast4 from "../CardLast4";
import { DATE_FORMAT } from "../../../../constants";
import { CopyToClipboard } from "../../../../components/ui";
import { IntlFormatUSD } from "../../../../utils";
import { STATUSES_COLORS } from "../../constants";

const TableBody = (): React.ReactElement => {
  const { relatedTables } = useSearchCustomersContext();
  const customers = useSelector((state) => state.customers.data.accounts);

  return (
    <tbody>
      {customers.map((customer) => {
        const expiresDate = get(customer, "account_plans.expires", "");
        const isValidDate = moment(expiresDate).isValid();

        const category: string = customer.account_category || "";

        return (
          <Box
            component="tr"
            key={`${customer.id}`}
            sx={{
              ...(category &&
                STATUSES_COLORS[category] && {
                  backgroundColor: STATUSES_COLORS[category].color,
                }),
            }}
          >
            <td>
              <CopyToClipboard value={customer.id} />
            </td>
            <td>
              <MenuItem
                component={Link}
                to={`/customer/${customer.id}`}
                sx={{ whiteSpace: "break-spaces" }}
              >
                {customer.name}
              </MenuItem>
            </td>
            <td>
              <CopyToClipboard value={customer.email} />
            </td>
            <td>{moment(customer.joined).utc().format(DATE_FORMAT)}</td>
            <td>{customer.country.name}</td>
            {relatedTables.includes("stateprov") && <td>{customer.stateprov}</td>}
            <td>{get(customer, "account_plans.plan.name", "")}</td>
            <td>{isValidDate ? moment(expiresDate).format(DATE_FORMAT) : "n/a"}</td>

            {relatedTables.includes("last4") && <CardLast4 last4={customer.last4} />}

            {relatedTables.includes("billing_histories") && (
              <td>{IntlFormatUSD(+get(customer, "billing_histories.total", 0) / 100)}</td>
            )}

            {relatedTables.includes("account_notes") && (
              <Box component="td" sx={{ whiteSpace: "pre-line" }}>
                {get(customer, "account_notes.note", "")
                  .split("|||")
                  .map((val: string) => (
                    <div key={val}>{val}</div>
                  ))}
              </Box>
            )}

            {relatedTables.includes("account_agreements") && (
              <td>{get(customer, "account_agreements.status", "")}</td>
            )}

            {relatedTables.includes("account_flags") && (
              <td>{get(customer, "account_flags.flag", "")}</td>
            )}
            {relatedTables.includes("free_reset") && <td>{customer.free_reset}</td>}
            {relatedTables.includes("phone") && <td>{customer.phone}</td>}
          </Box>
        );
      })}
    </tbody>
  );
};

export default TableBody;
